import { render } from "./OptionStockForm.vue?vue&type=template&id=ba386512&scoped=true"
import script from "./OptionStockForm.vue?vue&type=script&lang=ts"
export * from "./OptionStockForm.vue?vue&type=script&lang=ts"

import "./OptionStockForm.vue?vue&type=style&index=0&id=ba386512&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba386512"

export default script